import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonUtilService } from '../../../services/CommonUtil.service';
import { UniversalSearchPhoneNumberDto } from '../../../dto';

@Component({
    selector: 'app-contact-overview-icons',
    templateUrl: './contact-overview-icons.component.html',
    styleUrls: ['./contact-overview-icons.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ContactOverviewIconsComponent {
    @Input() email: string;
    @Input() isOpened: boolean;
    @Input() personalEmail: string;
    @Input() phoneNumbers: UniversalSearchPhoneNumberDto[];
    @Input() primaryDomain: any;
    @Input() socialProfiles: any[];
    @Input() purchaseHistory: any;

    constructor(public readonly commonUtilService: CommonUtilService) {

    }

}
